import { render, staticRenderFns } from "./addGameNameExclude.vue?vue&type=template&id=069ef882&lang=pug"
import script from "./addGameNameExclude.vue?vue&type=script&lang=js"
export * from "./addGameNameExclude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports